import BranchesType from "./actionTypes"



// function that called as action
const getListPage = data => ({
  type: BranchesType.GET_BRANCHES_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPageSuccess = data => ({
  type: BranchesType.GET_BRANCHES_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getListHistoryPage = data => ({
  type: BranchesType.GET_BRANCHES_HISTORIES_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListHistoryPageSuccess = data => ({
  type: BranchesType.GET_BRANCHES_HISTORIES_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getDetail = (data, action) => ({
  type: BranchesType.GET_DETAIL_BRANCH_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: BranchesType.GET_DETAIL_BRANCH_BY_ID_SUCCESS,
  payload: data,
})

// function that called as action
const postData = (data, action) => ({
  type: BranchesType.POST_BRANCH,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postDataSuccess = data => ({
  type: BranchesType.POST_BRANCH_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => {
  console.log('masuuuuu')
  return {
    type: BranchesType.PUT_BRANCH,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: BranchesType.PUT_BRANCH_SUCCESS,
  payload: data,
})

// function that called as action
const getBettingRatesList = data => ({
  type: BranchesType.GET_BRANCH_BETTING_RATE_TYPE,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getBettingRatesListSuccess = data => ({
  type: BranchesType.GET_BRANCH_BETTING_RATE_TYPE_SUCCESS,
  payload: data,
})


// function that called as action
const getList = data => ({
  type: BranchesType.GET_BRANCHES_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListSuccess = data => ({
  type: BranchesType.GET_BRANCHES_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getIgarashiList = data => ({
  type: BranchesType.GET_BRANCH_IGARASHI_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getIgarashiListSuccess = data => ({
  type: BranchesType.GET_BRANCH_IGARASHI_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getOtherList = data => ({
  type: BranchesType.GET_BRANCH_OTHER_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getOtherListSuccess = data => ({
  type: BranchesType.GET_BRANCH_OTHER_LIST_SUCCESS,
  payload: data,
})

const BranchesAction = {
  getListPage,
  getListPageSuccess,

  getListHistoryPage,
  getListHistoryPageSuccess,

  getBettingRatesList,
  getBettingRatesListSuccess,

  getDetail,
  getDetailSuccess,


  postData,
  postDataSuccess,

  putData,
  putDataSuccess,

  getList,
  getListSuccess,

  getIgarashiList,
  getIgarashiListSuccess,

  getOtherList,
  getOtherListSuccess

}

export default BranchesAction





